module.exports = __webpack_public_path__ + "img/002.bac952cb.png";